import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box, Typography } from '@mui/material'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { useManageState } from './useManageState'
import StateComponents from '../../../../components/state-component/StateComponents'
import TableCustom from '../../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../../utils/app.utils'
import { icons } from '../../../../assets/icons/icons'
import ModalCustom from '../../../../components/modal/modalCustomCms'
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom'
import { media_type_data } from '../../enum/elibrary_enum'

type Props = {}

const ManageLibraryAuthor: React.FC<Props> = ({ }: Props) => {
    const {
        pathname,
        data,
        end_date,
        handleChangeDateRange,
        handleRequestSort,
        headCells,
        page,
        pageLimit,
        renderData,
        setPage,
        setPageLimit,
        set_search,
        sortBy,
        sortType,
        start_date,
        totalItems,
        handleCloseModal,
        showModal,
        set_showModal,
        handleSubmit,
        setFormState,
        formState
    } = useManageState();
    return (
        <ContainerLayout
            title='จัดการสำนักพิมพ์/ผู้เขียน/สังกัด'
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "A",
                            name: "จัดการข้อมูล E-Library",
                            pathName: "จัดการข้อมูล E-Library",
                            disabled_match: true
                        },
                        {
                            key: "B",
                            name: "จัดการสำนักพิมพ์/ผู้เขียน/สังกัด",
                            pathName: pathname
                        },
                    ]}
                />
            }
            content={
                <Box>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                fieldProps: {
                                    startAdornment: <Box sx={{ mr: 1 }}><icons.SearchNormal /></Box>,
                                    placeholder: "ค้นหา ชื่อ",
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: set_search })
                                }
                            },
                            {
                                seq: 3,
                                type: "DATE_RANGE2",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3,
                                },
                                fieldProps: {
                                    handleChange: handleChangeDateRange,
                                    placeholder: "ช่วงวันที่",
                                    value: {
                                        end_date: end_date,
                                        start_date: start_date
                                    }
                                }
                            },
                            {
                                seq: 4,
                                type: "BUTTON",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                },
                                fieldProps: {
                                    justifyContent: "flex-end",
                                    buttonData: [
                                        {
                                            seq: 1,
                                            maxWidth: 'fix-content',
                                            buttonProps: {
                                                onClick: () => set_showModal("ADD")
                                            },
                                            key: "เพิ่ม",
                                            label: "เพิ่ม",
                                            type: "ADD"
                                        }
                                    ],
                                }
                            }
                        ]}
                    />



                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>


                    {showModal !== "" && (
                        <ModalCustom
                            handleClose={handleCloseModal}
                            onClick={handleSubmit}
                            open
                            enable_up_transition
                            title='เพิ่มสำนักพิมพ์/ผู้เขียน/สังกัด'
                            subTitle='กรุณาระบุรายละเอียด'
                            hintSubmitButton={showModal === 'VIEW'}
                            disabledSubmitButton={!formState.library_author_name}
                            scrollBody
                            form={
                                <Box className="w-full py-4">
                                    <StateComponents
                                        disabledAllField={showModal === 'VIEW'}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                type: "TEXT_FIELD",
                                                fieldProps: {
                                                    heading: "ชื่อ",
                                                    value: formState.library_author_name,
                                                    onChange: (e) => setFormState((prev) => ({ ...prev, library_author_name: e.target.value })),
                                                    placeholder: "ระบุชื่อ",
                                                    required: true
                                                }
                                            },
                                        ]}
                                    />
                                </Box>
                            }
                        />
                    )}
                </Box>
            }
        />
    )
}

export default ManageLibraryAuthor